import { AxSlide } from "../../../Components/AxSlide/AxSlide";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../../Lib/Helper/I18nHelper";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { AxTab } from "../../../Limestone/AxPortlet/AxTab";
import { ITimeSlot, TimeSlotEntry } from "../../../Models/Reservation/TimeSlot";
import { TimeSlotKey } from "../../../Models/Reservation/TimeSlotKey";
import { ProgressBar, ProgressBarMode } from "../../Global/Progressbar";
import { AxProdSelection } from "../AxProdSelection";
import { SummaryRedirect } from "../../../Lib/Helper/AxProdSelection/SummaryRedirect";
import { TimeSlotDay } from "../../../Models/Reservation/TimeSlotDay";
import { ConfigHelper, ConfigDefinition } from "../../../Lib/Helper/Config/ConfigHelper";
import { CheckMinMaxConstraintResult, PackageMinMaxConstraint } from "../../Packages/PackageMinMaxConstraint";
import { DateHelper } from "../../../Lib/Helper/DateHelper";

export abstract class AxBooking {
    protected productSelection: AxProdSelection;
    protected selectedDate: string;
    protected postURL: string;
    protected selectedTimeSlots: ITimeSlot[] = [];

    private selectedDateCI: string;
    private datePattern: string;
    private timeSlotList: TimeSlotEntry[];
    private timeSlotDayList: TimeSlotDay[] = [];
    private timeSlotGroupKeyList: number[] = [];
    private isFirstLoad: boolean = true;
    private hideEarlierTimeSlots: boolean;

    constructor(private i18nHelper = new I18nHelper(),
        protected _summaryRedirect = new SummaryRedirect(),
        private progressbar = new ProgressBar(),
        private _AxLimeStone = new AxLimeStone(),
        private _Slide = new AxSlide(),
        private _AxTab = new AxTab()) {
    }

    abstract AddToCart(): void;

    Init(initData: AxProdBookingInit): void {
        this.selectedDateCI = initData.dateCI;
        this.selectedDate = initData.date;
        this.postURL = initData.postURL;
        this.datePattern = initData.datePattern;

        this.progressbar.Init({
            Mode: ProgressBarMode.Suballotment,
            Progress: 1
        });

        this.initTimeSlotList(initData);

        ConfigHelper.getBoolConfigValueAsync(ConfigDefinition.SubContingentLockAllEarlier)
            .then(x => {
                this.hideEarlierTimeSlots = x;

                if (this.hideEarlierTimeSlots) {
                    const allTabs = $('.tv4_contingent__selection-portlet .ax-tabs li');
                    allTabs.addClass('timeslot-tab-unselecteble');
                    this.inactivateInvalidSlots(0);
                }
            });


        this.productSelection = AxLoad.GetModule<AxProdSelection>("AxProdSelection");

        this.productSelection.InteractionSubject.subscribe(x => {
            this.CheckContingents(this.isFirstLoad);
            this.isFirstLoad = false;
            this.ToggleDisableSubmit();
        });

        this.productSelection.SubmitSubject.subscribe(x => {
            this.AddToCart();
        });


        $('.product_selection__setting_date--placeholder').addClass('d-none');
        $('.product_selection__setting_date').removeClass('d-none').html(this.selectedDateCI);

        $('.product_selection__allotment_lang button').click(e => {
            this.ActivateLanguage($(e.currentTarget).data('langid'));
        });

        this.ActivateLanguage($('.product_selection__allotment_lang button')?.first()?.data('langid') ?? $('.product_selection__allotment_selection')?.first()?.data('langid') ?? 0);
        $('.prod_selection__selection-submit').html(this.i18nHelper.GetTranslation(Translations.Reserve));

        $('.product_selection__allotment_selection button.ax-chip').click(e => {
            this.SelectionContingent(e.currentTarget);
        });


        $('#tv4_side__selection-timing--toggle').click(e => {
            this.ToggleTimings();
        });

        this.initMultiTabEvents();
        this.initMultiDayEvents();
    }

    initMultiTabEvents() {
        if ($('.tv4_contingent__selection-portlet .ax-tabs').length > 0) {

            this._AxTab.Init('.tv4_contingent__selection-portlet .ax-tabs');
            $('.prod_selection__selection-submit-goNext').click(e => {
                this.NextTab();
            });

            $('.prod_selection__selection-next-submit').click(e => {
                this.NextTab();
            });
        }

        let $activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');

        if ($activeTab.length > 0) {
            $('.prod_selection__selection-submit-goNext').removeClass('d-none');
            $('.prod_selection__selection-submit').addClass('d-none');
        }
        else {
            $('.prod_selection__selection-submit').removeClass('d-none');
            $('.prod_selection__selection-submit-goNext').addClass('d-none');
        }
    }

    initMultiDayEvents() {
        //Only Multicontingent stuff
        if ($('.tv4_contingent__selection-header').length > 0) {
            $('.product_selection__allotment_selection').on('click', 'button.prev', (e) => {
                const $target = $(e.delegateTarget).find('.product_selection__list_content > div');
                const targetWidth = $target.width();
                let currTrans = parseInt(($target.css("transform").split(",")[4] ?? "0").trim()) * -1;

                if (currTrans - targetWidth < 0) {
                    currTrans = 0;
                } else {
                    currTrans = currTrans - targetWidth;
                }

                $target.css('transform', `translateX(${currTrans * -1}px)`);
            });

            $('.product_selection__allotment_selection').on('click', 'button.next', (e) => {
                const $target = $(e.delegateTarget).find('.product_selection__list_content > div');
                const targetWidth = $target.width();
                const scrollAbleWidth = $target.find('.tv4_contingent__timeSlotGrid')[0].scrollWidth;

                let currTrans = parseInt(($target.css("transform").split(",")[4] ?? "0").trim()) * -1;

                if (currTrans + targetWidth > scrollAbleWidth - targetWidth) {
                    currTrans = scrollAbleWidth - targetWidth;
                } else {
                    currTrans = currTrans + targetWidth;
                }

                $target.css('transform', `translateX(${currTrans * -1}px)`);
            });

            const resizeObserver = new ResizeObserver(resizeEntries => {
                for (let entry of resizeEntries) {
                    $(entry.target).children().each((i, e) => {
                        if (Math.ceil(entry.contentBoxSize[0].inlineSize) < $(e).find('.tv4_contingent__timeSlotGrid')[0].scrollWidth) {
                            $(e).find('.product_selection__list_slide').removeClass('d-none');
                        } else {
                            $(e).find('.product_selection__list_slide').addClass('d-none');
                        }
                    });
                }
            });
            resizeObserver.observe(document.querySelector('.tv4_contingent__selection'));

            $(`.product_selection__timeSlot_switch`).change(x => {
                const $target = $(x.currentTarget);
                const timeSlotGroupKey = parseInt($target.attr('data-target'));

                if ($target.prop('checked')) {
                    const selectedIndex = this.selectedTimeSlots.findIndex(x => x.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey);

                    if (selectedIndex != -1) {
                        const tmpSlot = this.selectedTimeSlots[selectedIndex];
                        this.SelectNearestTimeSlots(tmpSlot);
                        this.productSelection.InteractionSubject.next(null);
                    }
                } else {
                    $(`.product_selection__timeSlot_danger[data-target="${timeSlotGroupKey}"]`).addClass('d-none');
                }
            });

            this._Slide.Init({
                Slider: $('.product_selection__allotment_selection'),
                HolderSelector: '.product_selection__list_content > div',
                ElemSelector: '.tv4_contingent__selection-list > div'
            });
            this._AxLimeStone.Alert('.product_selection__timeSlot_danger');
        }
    }

    ActivateLanguage(langID: number): void {
        $(`.product_selection__allotment_lang button`).removeClass('ax-chip--active');
        $(`.product_selection__allotment_lang button[data-langid=${langID}]`).addClass('ax-chip--active');

        $('.product_selection__allotment_selection').addClass('d-none');
        $(`.product_selection__allotment_selection[data-langid=${langID}]`).removeClass('d-none');
    }

    NextTab(): void {
        const $activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');

        if (this.hideEarlierTimeSlots) {
            $activeTab.addClass('timeslot-tab-checked');
        }

        $('.prod_selection__summary-next').fadeOut('fast');
        if ($activeTab.next('li').is(':last-child')) {
            $('.prod_selection__selection-submit-goNext').addClass('d-none');
            $('.prod_selection__selection-submit').removeClass('d-none');
        }
        this._AxTab.ActivateTab($activeTab.next().attr('data-target'));
    }

    CheckContingents(isFirstLoad: boolean) {
        let sumQuantity: number = 0;
        for (let prod of this.productSelection.ProductListTmp.filter(x => x.TimeSlotGroupKeys != null && x.TimeSlotGroupKeys.length > 0)) {
            sumQuantity += prod.Quantity;
        }

        for (let slot of this.timeSlotList) {
            const $tmpButton: JQuery<Element> = $(slot.elem);
            const free: number = slot.availableSlots;

            let newStatus: string = null;
            const oldStatus: string = $tmpButton.attr('data-contingentstatus');

            $tmpButton.removeClass(`ax-fill-${oldStatus}-500`);
            $tmpButton.removeClass(`ax-outline-${oldStatus}-500`);

            if (!isFirstLoad) {
                newStatus = oldStatus;
            } else if (free <= slot.warningThreshold || free <= slot.limitedThreshold) {
                newStatus = 'orange';
            } else {
                newStatus = 'green';
            }

            $tmpButton.attr('data-contingentstatus', newStatus);
            const childSpan = $tmpButton.find(".subConti_span");
            const childIcon = $tmpButton.find(".subConti_spanDiv").find('.las');
            if (free > 0 && free >= sumQuantity) {
                $tmpButton.removeClass('line-through');
                if (this.selectedTimeSlots.filter(x => x.timeSlotKey.equal(slot.timeSlotKey)).length >
                    0) {
                    $tmpButton.addClass(`ax-fill-${newStatus}-500`);
                } else {
                    $tmpButton.addClass(`ax-outline-${newStatus}-500`);
                }

                if (childSpan.length > 0) {
                    let availabilityText = slot.total > 0 ? `${free}/${slot.total}` : free.toString();

                    availabilityText += ' ' + this.i18nHelper.GetTranslation(Translations.Free);
                    childSpan.text(availabilityText);
                }
                $tmpButton.find(".subConti_name").removeClass('line-through');
                childIcon.removeClass('la-calendar-times');
                childIcon.addClass('la-calendar-check');
            } else {
                $tmpButton.find(".subConti_name").addClass('line-through');
                childSpan.text(`${this.i18nHelper.GetTranslation(Translations.SoldOut)}`);
                childIcon.removeClass('la-calendar-check');
                childIcon.addClass('la-calendar-times');
            }

            if (free < sumQuantity && this.selectedTimeSlots.filter(x => x.timeSlotKey.equal(slot.timeSlotKey)).length > 0) {
                this.DeactivateContingent(slot.timeSlotKey);
            }
        }
    }

    CheckSuballotmentQuantity(timeSlotKey: TimeSlotKey) {
        let sumQuantity: number = 0;
        for (let prod of this.productSelection.ProductListTmp.filter(x => x.TimeSlotGroupKeys != null && x.TimeSlotGroupKeys.length > 0)) {
            sumQuantity += prod.Quantity;
        }

        const slot = this.GetTimeSlot(timeSlotKey);
        return slot.availableSlots >= sumQuantity;
    }

    DeactivateContingent(timeSlotKey: TimeSlotKey) {
        const index: number = this.selectedTimeSlots.findIndex(x => x.timeSlotKey.equal(timeSlotKey));
        if (index > -1) {
            this.selectedTimeSlots.splice(index, 1);
        }

        $(`.product_selection__allotment_selection button[data-timeSlotGroupKey="${timeSlotKey.timeSlotGroupKey}"][data-timeSlotKey1="${timeSlotKey.timeSlotKey1}"][data-timeSlotKey2="${timeSlotKey.timeSlotKey2}"]`).each((i, tmpButton) => {
            const $tmpButton: JQuery<Element> = $(tmpButton);
            const tmpColor: string = $tmpButton.attr('data-contingentstatus');
            $tmpButton.removeClass(`ax-fill-${tmpColor}-500`);
        });

        this.PrintSelectedContingents();
    }

    SelectionContingent(e: Element, triggerChecks: boolean = true): void {
        const $elem: JQuery<Element> = $(e);
        const color: string = $elem.attr('data-contingentstatus');
        const timeSlotGroupKey: number = parseInt($elem.attr('data-timeSlotGroupKey'));
        const timeSlotKey1: string = $elem.attr('data-timeSlotKey1');
        const timeSlotKey2: number = parseInt($elem.attr('data-timeSlotKey2'));

        const timeSlotKey: TimeSlotKey = new TimeSlotKey(timeSlotGroupKey, timeSlotKey1, timeSlotKey2);

        if (this.CheckSuballotmentQuantity(timeSlotKey)) {
            const currentTimeSlot = this.GetTimeSlot(timeSlotKey);

            for (let timeSlot of this.selectedTimeSlots.filter(x => x.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey && x.day.isSame(currentTimeSlot.day))) {
                const $tmpButton = $(`.product_selection__allotment_selection button[data-configno="${timeSlot.timeSlotKey.timeSlotGroupKey}"][data-timeSlotKey1="${timeSlot.timeSlotKey.timeSlotKey1}"][data-timeSlotKey2="${timeSlot.timeSlotKey.timeSlotKey2}"]`);
                const tmpColor: string = $tmpButton.attr('data-contingentstatus');
                $tmpButton.removeClass(`ax-fill-${tmpColor}-500`).addClass(`ax-outline-${tmpColor}-500`);
            }

            const index: number = this.selectedTimeSlots.findIndex(x => x.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey && x.day.isSame(currentTimeSlot.day));
            if (index > -1) {
                this.selectedTimeSlots.splice(index, 1);
            }

            this.selectedTimeSlots.push({
                timeSlotKey: timeSlotKey,
                day: currentTimeSlot.day,
                time: currentTimeSlot.time
            });

            this.PrintSelectedContingents();
            $elem.removeClass(`ax-outline-${color}-500`).addClass(`ax-fill-${color}-500`);

            if (triggerChecks) {
                if ($(`.product_selection__timeSlot_switch[data-target="${timeSlotGroupKey}"]`).prop('checked')) {
                    this.SelectNearestTimeSlots(currentTimeSlot);
                }
                this.productSelection.InteractionSubject.next(e);
            }
        }

        //this.ResetHideEarlierSlots();
        const selectedSoapTime: string = $elem.attr('data-slot-startTime');
        this.HideEarlierSlots(selectedSoapTime);
    }

    // UnHideEarlierSlots
    ResetHideEarlierSlots() {
        $('.earlier-timeSlot-inactive').removeClass('earlier-timeSlot-inactive');
        $('.earlier-timeSlot-header-inactive').removeClass('earlier-timeSlot-header-inactive');
    }

    // HideEarlierSlots
    async HideEarlierSlots(selectedSoapTime: string) {
        if (!this.hideEarlierTimeSlots) {
            return;
        }

        const activeTabSortNrAttr = $('.tv4_contingent__selection-portlet .ax-tabs li.active').attr('data-sortnr');
        const activeTabSortNr = parseInt(activeTabSortNrAttr);

        const allTabs = $('.tv4_contingent__selection-portlet .ax-tabs li');

        if (allTabs.length <= 1) {
            return;
        }

        const allSorts = new Array<number>();

        const selectedMoment = DateHelper.soapDateTimeToMoment(selectedSoapTime);

        const selectedHour = selectedMoment.hour();

        for (let i = 0; i < allTabs.length; i++) {
            const sortNr = $(allTabs[i]).attr('data-sortnr');
            allSorts.push(parseInt(sortNr));
        }

        const inactiveSorts = allSorts.filter(x => x != activeTabSortNr);

        for (let sort of inactiveSorts) {

            const inactiveTab = $(`[data-sortnr="${sort}"]`);

            // if the tab is after the active tab
            if (parseInt(inactiveTab.attr('data-sortnr')) > activeTabSortNr) {
                const dataTarget = $(inactiveTab).attr('data-target');

                const tsHolder = $(`.product_selection__allotment_tab_content[data-target="${dataTarget}"]`);

                const allotmentTimeContainer = tsHolder.find('.product_selection__allotment_time-container');

                for (let i = 0; i < allotmentTimeContainer.length; i++) {
                    const hourInHeader = parseInt($(allotmentTimeContainer[i]).attr('data-hour'));
                    const soapDateInHeader = $(allotmentTimeContainer[i]).attr('data-soap-date');
                    const momentDateInHeader = DateHelper.soapDateToMoment(soapDateInHeader);

                    if (momentDateInHeader.isSame(selectedMoment, 'day') && hourInHeader < selectedHour) {
                        $(allotmentTimeContainer[i]).addClass('earlier-timeSlot-header-inactive');
                    }
                }

                const chips = tsHolder.find('.ax-chip');

                for (let i = 0; i < chips.length; i++) {
                    const chipSoapTime = $(chips[i]).attr('data-slot-startTime');
                    const chipMoment = DateHelper.soapDateTimeToMoment(chipSoapTime);

                    if (chipMoment.isSame(selectedMoment, 'day') && chipMoment.diff(selectedMoment) <= 0) {
                        const thisChip = $(chips[i]);
                        $(thisChip).addClass('earlier-timeSlot-inactive');
                    } else {
                        const thisChip = $(chips[i]);
                        $(thisChip).removeClass('earlier-timeSlot-inactive');
                    }
                }
            }
        }

        this.inactivateInvalidSlots(activeTabSortNr);
    }

    // inactivate timesSlots where no valid slot afterwards is available
    inactivateInvalidSlots(startIndex: number) {
                const allTabs = $('.tv4_contingent__selection-portlet .ax-tabs li');

        let allSorts = new Array<number>();

        for (let i = 0; i < allTabs.length; i++) {
            const sortNr = $(allTabs[i]).attr('data-sortnr');
            allSorts.push(parseInt(sortNr));
        }

        allSorts = allSorts.sort((a, b) => a - b);

        for (let sortIndex = startIndex; sortIndex < (allSorts.length - 1); sortIndex++) {

            const activeTab = $(`[data-sortnr="${allSorts[sortIndex]}"]`);
            const dataTargetActiveTab = $(activeTab).attr('data-target');
            const tsHolderActive = $(`.product_selection__allotment_tab_content[data-target="${dataTargetActiveTab}"]`);
            const activeTabChips = tsHolderActive.find('.ax-chip');

            const nextTab = $(`[data-sortnr="${allSorts[sortIndex] + 1}"]`);
            const dataTargetNext = $(nextTab).attr('data-target');
            const tsHolderNext = $(`.product_selection__allotment_tab_content[data-target="${dataTargetNext}"]`);
            const nextTabsChips = tsHolderNext.find('.ax-chip');

            for (let i = 0; i < activeTabChips.length; i++) {
                const chipSoapTime = $(activeTabChips[i]).attr('data-slot-startTime');
                const activeChipMoment = DateHelper.soapDateTimeToMoment(chipSoapTime);

                let laterExists = this.checkIfLaterSlotExists(nextTabsChips, activeChipMoment);
                if (!laterExists) {
                    const thisChip = $(activeTabChips[i]);
                    $(thisChip).addClass('earlier-timeSlot-inactive');
                }
            }
        }
    }

    // checkIfLaterSlotExists
    checkIfLaterSlotExists(nextTabsChips: any, activeChipMoment: moment.Moment): boolean {
        for (let j = 0; j < nextTabsChips.length; j++) {

            const nextTabChipSoapTime = $(nextTabsChips[j]).attr('data-slot-startTime');
            const nextTabChipMoment = DateHelper.soapDateTimeToMoment(nextTabChipSoapTime);

            if (nextTabChipMoment.isAfter(activeChipMoment)) {

                return true;
            }
        }

        return false;
    }

    SelectNearestTimeSlots(timeSlot: ITimeSlot) {
        const time = timeSlot.time;
        let nearestTimeSlot: TimeSlotEntry;

        let alwaysSame = true;

        for (let slotDay of this.timeSlotDayList.filter(x => x.timeSlotGroupKey == timeSlot.timeSlotKey.timeSlotGroupKey && !x.day.isSame(timeSlot.day))) {
            let currentOffset = 9999;

            for (let tmpSlot of this.timeSlotList.filter(x => x.timeSlotKey.timeSlotGroupKey == slotDay.timeSlotGroupKey && x.day.isSame(slotDay.day))) {
                let offset = time - tmpSlot.time;
                if (offset < 0) { offset = offset * -1; }

                if (offset < currentOffset && this.CheckSuballotmentQuantity(tmpSlot.timeSlotKey)) {
                    nearestTimeSlot = tmpSlot;
                    currentOffset = offset;

                    if (offset == 0) {
                        break;
                    }
                }
            }

            if (currentOffset != 0) {
                alwaysSame = false;
            }
            this.SelectionContingent(nearestTimeSlot.elem, false);
        }
        $(`.product_selection__timeSlot_danger[data-target="${timeSlot.timeSlotKey.timeSlotGroupKey}"]`).toggleClass('d-none', alwaysSame);
    }

    PrintSelectedContingents() {
        const $template = $('.product_selection__setting_timeSlot--entry');
        $(`.product_selection__setting_timeSlot`).html('');
        $('.product_selection__setting_timeSlot--placeholder').removeClass('d-none');


        for (let timeSlotDay of this.timeSlotDayList) {
            const configNo = timeSlotDay.timeSlotGroupKey;
            const multiDay: boolean = this.timeSlotDayList.filter(x => x.timeSlotGroupKey == configNo).length > 1;

            const selectedSlot = this.selectedTimeSlots.filter(x => x.timeSlotKey.timeSlotGroupKey == configNo && x.day.isSame(timeSlotDay.day));

            if (selectedSlot.length > 0) {
                $(`#tv4_side__selection-tab > div[data-target="${configNo}"] .product_selection__setting_timeSlot--placeholder`).addClass('d-none');
                const timeSlot = this.GetTimeSlot(selectedSlot[0].timeSlotKey);

                let label = '';
                if (multiDay) {
                    label += `${timeSlot.day.format(this.datePattern)}, `;
                }
                label += $(timeSlot.elem).find('.subConti_name').html();

                const $entry = $template.clone();
                $entry.removeClass('d-none product_selection__setting_timeSlot--entry').html(label);
                $(`#tv4_side__selection-tab > div[data-target="${configNo}"] .product_selection__setting_timeSlot`).append($entry);
            }
        }
    }


    ToggleTimings() {
        $('#tv4_side__selection-timing').slideToggle('fast');

        $('#tv4_side__selection-timing--toggle i').toggleClass('las la-angle-down');
        $('#tv4_side__selection-timing--toggle i').toggleClass('las la-angle-up');
    }

    ToggleDisableSubmit() {
        let quantityFound = this.productSelection.GetTotalQuantity() > 0;

        if (!quantityFound) {
            $('.prod_selection__summary').fadeOut('fast');
            $('.prod_selection__selection-submit').attr('disabled', 'disabled');
            return;
        }

        let activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');

        if (activeTab.length > 0) {
            if (!activeTab.is(':last-child')) {

                let configActiveTab = parseInt(activeTab.attr('data-target'));
                if (this.selectedTimeSlots.filter(x => x.timeSlotKey.timeSlotGroupKey == configActiveTab).length == this.timeSlotDayList.filter(x => x.timeSlotGroupKey == configActiveTab).length) {
                    $('.prod_selection__summary-next').fadeIn('fast');
                    $('.prod_selection__selection-submit-goNext').removeAttr('disabled');

                    if (this.selectedTimeSlots.length == this.timeSlotDayList.length) {
                        $('.prod_selection__selection-submit-goNext').addClass('d-none');
                    } else {
                        $('.prod_selection__selection-submit-goNext').removeClass('d-none');
                    }
                }

                if (this.hideEarlierTimeSlots) {
                    $('.prod_selection__selection-submit-goNext').removeClass('d-none');
                    $('.prod_selection__selection-submit').addClass('d-none');
                    $('.prod_selection__summary-next').fadeIn('fast');
                }

            } else {
                $('.prod_selection__summary-next').fadeOut('fast');
                $('.prod_selection__selection-submit-goNext').attr('disabled', 'disabled');
                $('.prod_selection__selection-submit-goNext').addClass('d-none');
            }
        }
        else {
            $('.prod_selection__selection-submit-goNext').addClass('d-none');
        }

        if (this.selectedTimeSlots.length !== this.timeSlotDayList.length) {
            $('.prod_selection__selection-submit').attr('disabled', 'disabled');
            return;
        }

        let minMaxConstraintModule = AxLoad.GetModule<PackageMinMaxConstraint>('PackageMinMaxConstraint');

        if (minMaxConstraintModule != null) {
            let checkMinMaxConstraintResult = minMaxConstraintModule.CheckMinMaxConstraint(this.productSelection.GetTotalQuantity());

            if (checkMinMaxConstraintResult.minMaxOk) {
                if (activeTab.is(':last-child') || activeTab.length === 0) {
                    $('.prod_selection__selection-submit').removeClass('d-none');
                    $('.prod_selection__selection-submit').removeAttr('disabled');
                }
                //$('.prod_selection__selection-submit').html(this.i18nHelper.GetTranslation(Translations.Next));

            } else {
                $('.prod_selection__selection-submit').attr('disabled', 'disabled');
                $('.prod_selection__selection-submit').html(checkMinMaxConstraintResult.errorMessage);
            }
        } else {
            if (activeTab.is(':last-child') || activeTab.length === 0) {
                $('.prod_selection__selection-submit').removeClass('d-none');
                $('.prod_selection__selection-submit').removeAttr('disabled');
            }
        }

        this.LoadSummary(quantityFound);
    }

    LoadSummary(quantityOk: boolean): void {
        if (quantityOk) {
            this.productSelection.Apply();

            let quantity: number = 0;
            let summaryText: string;
            let dateText: string = `${this.selectedDateCI}`;

            if (this.selectedTimeSlots.length == 1) {
                const tmpSlot = this.GetTimeSlot(this.selectedTimeSlots[0].timeSlotKey);
                dateText += `, ${tmpSlot.elem.innerHTML}`;
            }

            for (let prod of this.productSelection.ProductList) {
                quantity += prod.Quantity;
            }
            summaryText = quantity.toString();

            if (quantity == 1) {
                summaryText += ` ${this.i18nHelper.GetTranslation(Translations.Ticket)}`;
            } else {
                summaryText += ` ${this.i18nHelper.GetTranslation(Translations.Tickets)}`;
            }

            const $activeLang = $('.product_selection__allotment_lang button.ax-chip--active');
            if ($activeLang.length > 0) {
                dateText += $activeLang.html() + ' ';
            }

            $('.prod_selection__summary-date').html(dateText);
            $('.prod_selection__summary-subtotal').html(summaryText);
            $('.prod_selection__summary-subtotal--price').html(this.productSelection.Total);

            $('.prod_selection__summary').fadeIn('fast');
        } else {
            $('.prod_selection__summary').fadeOut('fast');
        }
    }

    GetProductSum(): number {
        let sumQuantity: number = 0;
        for (let prod of this.productSelection.ProductListTmp) {
            sumQuantity += prod.Quantity;
        }
        return sumQuantity;
    }


    GetTimeSlot(timeSlotKey: TimeSlotKey): TimeSlotEntry {
        return this.timeSlotList.find(x => x.timeSlotKey.equal(timeSlotKey));
    }

    initTimeSlotList(init: AxProdBookingInit) {
        this.timeSlotList = [];
        for (let slot of init.timeSlots) {
            slot.timeSlotKey = new TimeSlotKey(slot.timeSlotKey.timeSlotGroupKey,
                slot.timeSlotKey.timeSlotKey1,
                slot.timeSlotKey.timeSlotKey2);
            this.timeSlotList.push(slot);
        }

        for (let slot of this.timeSlotList) {
            slot.day = moment(slot.date, 'YYYY-MM-DD');

            let tmpDay: TimeSlotDay = {
                day: slot.day,
                timeSlotGroupKey: slot.timeSlotKey.timeSlotGroupKey
            };
            if (this.timeSlotDayList.findIndex(x => x.timeSlotGroupKey == tmpDay.timeSlotGroupKey && x.day.isSame(slot.day)) == -1) {
                this.timeSlotDayList.push(tmpDay);
            }

            if (this.timeSlotGroupKeyList.findIndex(x => x == tmpDay.timeSlotGroupKey) == -1) {
                this.timeSlotGroupKeyList.push(tmpDay.timeSlotGroupKey);
            }
        }


        for (let slot of this.timeSlotList) {
            let tmpButton = $(`.product_selection__allotment_selection .product_selection__allotment_time-container button[data-timeSlotGroupKey="${slot.timeSlotKey.timeSlotGroupKey}"][data-timeSlotKey1="${slot.timeSlotKey.timeSlotKey1}"][data-timeSlotKey2="${slot.timeSlotKey.timeSlotKey2}"]`);
            slot.elem = tmpButton[0];
        }
    }
}

export interface AxProdBookingInit {
    dateCI: string;
    date: string;
    timeSlots?: TimeSlotEntry[];
    postURL: string;
    datePattern: string;
}
